export const Navbardata=[
    {
        id:1,
        Name:"Home",
        url:"/"
    },
    {
        id:2,
        Name:"Docs",
        url:"https://docs.google.com/document/d/1LQ9r118aYkt3kFbwmZO3Wq7m7BRgxyZS/edit"
    },
    {
        id:3,
        Name:"GitHub",
        url:"https://github.com/patelsatyamgit/DataDrivenReactApp"
    },
    {
        id:4,
        Name:"Json",
        url:"/demo"
    },
    {
        id:5,
        Name:"Users",
        url:"/user"
    },
    {
        id:6,
        Name:"Cart",
        url:"/cart"
    }
]